module.exports = __webpack_public_path__ + "static/media/wicket_title.de1276be.jpeg";